import React, { FC } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch, Action } from 'redux'
import { createStructuredSelector } from 'reselect'

import { actionCreators as orderActionCreators } from '@/checkout-instore-legacy/order/actions'
import { actionCreators as paymentActionCreators } from '@/checkout-instore-legacy/payment/actions'
import { setHasPreSelected } from '@/checkout-instore-legacy/returnExchange/actions'
import { preventMixedAddressId } from '@/checkout-instore-legacy/shipping/actions'
import Payment from './Payment'
import {
  orderSelector,
  shouldRefundPaymentsPaidSelector,
} from '@/checkout-instore-legacy/order/selectors'
import {
  splitPaymentsSelector,
  totalsPerSellerSelector,
} from '@/checkout-instore-legacy/payment/selectors'
import { vendorSelector } from '@/checkout-instore-legacy/vendor/selectors'
import { transactionOrderGroupIdSelector } from '@/checkout-instore-legacy/transfer/selectors'
import { giftCardShouldPreSelectExchangeSelector } from '@/checkout-instore-legacy/returnExchange/selectors'
import useNetwork from '@/checkout-instore-legacy/hooks/useNetwork'

const PaymentContainer: FC = (props) => {
  const paymentProps = {
    ...props,
    isOnline: useNetwork(),
  }

  return <Payment {...paymentProps} />
}

const mapStateToPropsSelector = createStructuredSelector({
  order: orderSelector,
  vendor: vendorSelector,
  shouldPreSelectGiftCard: giftCardShouldPreSelectExchangeSelector,
  splitPayments: splitPaymentsSelector,
  totalsPerSeller: totalsPerSellerSelector,
  orderGroupId: transactionOrderGroupIdSelector,
  shouldRefundPaymentsPaid: shouldRefundPaymentsPaidSelector,
})

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  ...bindActionCreators(
    {
      ...orderActionCreators,
      ...paymentActionCreators,
      setHasPreSelected,
      preventMixedAddressId,
    },
    dispatch
  ),
})

export default connect(
  mapStateToPropsSelector,
  mapDispatchToProps
)(PaymentContainer)
